<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>
<style lang="scss">
  .a-icon{
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .a-icon  i{
    font-size: 18px;
  }

  .vs-dropdown--custom {
    width: 220px;
  }
</style>

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right hover:text-white">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Alias')}}</label>
        <vs-input class="w-full" v-model="filters.description" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Status')}}</label>
        <v-select class="align-middle" :options="state_values" v-model="filters.status" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="doFilter()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <a v-if="urlDownload.length > 0" class="btn-primary float-right mt-4" :href="urlDownload" download="Agro.csv"><feather-icon icon="DownloadCloudIcon" /></a>
      </div>
    </div>
    <div id="data-list-list-view" class="data-list-container mt-2 px-">
      <vs-dropdown class="float-right mt-4 mr-5" vs-custom-content vs-trigger-click>
        <a class="a-icon" href.prevent>
          {{$t("Labels.ConfigView")}}
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-checkbox class="my-1" v-model="fields.description">{{$t('Labels.Alias')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="fields.temp">{{$t('Labels.GroundTemperature')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="fields.atemp">{{$t('Labels.EnvTemperature')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="fields.ahum">{{$t('Labels.Humidity')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="fields.rain_level">{{$t('Labels.Precipitation')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="fields.light_level">{{$t('Labels.Light')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="fields.updated_at">{{$t('Labels.Date')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="fields.status">{{$t('Labels.Status')}}</vs-checkbox>
          <div class="text-center">
            <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="saveConfig()" class="bg-primary" type="filled" size="small">{{$t("Labels.Save")}}</vs-button>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
      <vs-table v-if="response" ref="table" :data="response">
        <template>
          <tbody>
          <tr :key="index" @click="goToDetail(item.agro_id)" class="tr-values vs-table--tr tr-table-state-null selected" v-for="(item, index) in response">
              <listItem v-if="fields.description"
                :value="item.description"
                :description="$t('Labels.Alias')"
                img="agro"
              ></listItem>
              <listItem v-if="fields.temp"
                :value="parseFloat(item.temp).toFixed(2)"
                :description="$t('Labels.GroundTemperature')"
                img="temperature"
                unit="°C"
              ></listItem>
              <listItem v-if="fields.atemp"
                :value="parseFloat(item.atemp).toFixed(2)"
                :description="$t('Labels.EnvTemperature')"
                img="pressure"
                unit="°C"
              ></listItem>
              <listItem v-if="fields.ahum"
                :value="parseFloat(item.ahum).toFixed(2)"
                :description="$t('Labels.Humidity')"
                img="humedad"
                unit="%"
              ></listItem>
              <listItem v-if="fields.rain_level"
                :value="parseFloat(item.rain_level).toFixed(2)"
                :description="$t('Labels.Precipitation')"
                img="lluvia"
                unit="%"
              ></listItem>
              <listItem v-if="fields.light_level"
                :value="parseFloat(item.light_level).toFixed(2)"
                :description="$t('Labels.Light')"
                img="nivel_luz"
                unit="%"
              ></listItem>
              <listItem v-if="fields.updated_at"
                :value="item.updated_at.split(' ')[0]"
                :description="item.updated_at.split(' ')[1]"
                img="fecha"
              ></listItem>
              <listAlertItem v-if="fields.status" :status="item.status === 1? true: false"></listAlertItem>
          </tr>
          </tbody>
        </template>
      </vs-table>
      <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import listAlertItem from '@/components/listAlertItem/listAlertItem.vue'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'

export default {
  components: {
    'v-select': vSelect,
    listItem,
    listAlertItem,
    iconBase,
    iconFilterAsc,
    iconFilterDesc,
    iconFilter
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      state_values: [
        { label: 'Todos', value: '' },
        { label: 'Correcto', value: 0 },
        { label: 'Alerta', value: 1 }
      ],
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'updated_at',
        byOrder: 'ASC',
        description: '',
        status: ''
      },
      urlDownload: '',
      fields: {
        description: false,
        temp: false,
        atemp: false,
        ahum: false,
        rain_level: false,
        light_level: false,
        updated_at: false,
        status: false
      },
      fieldsView: [],
      showFilters: false,
      columnOrders: [
        { label: this.$t('Labels.Alias'), value: 'description' },
        { label: this.$t('Labels.Status'), value: 'status' },
        { label: this.$t('Labels.Date'), value: 'updated_at' }
      ],
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ]
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const params = {
        url: 'modelo/agro',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        if (this.response.length > 0) {
          this.fieldsView = this.response[0].see_data.split(',')
          this.fieldsView.forEach(element => {
            this.fields[element] = true
          })
        }
        this.setPages(response.data.data.count)
        this.createCsv()
      }).catch(() => {
        this.response = []
        this.setPages(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    goToDetail (uuid) {
      window.location.href = `/agro/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.Alias'))
      headers.push(this.$t('Labels.GroundTemperature'))
      headers.push(this.$t('Labels.EnvTemperature'))
      headers.push(this.$t('Labels.Humidity'))
      headers.push(this.$t('Labels.HumidityGround'))
      headers.push(this.$t('Labels.Precipitation'))
      headers.push(this.$t('Labels.Light'))
      headers.push(this.$t('Labels.Status'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.updated_at)
        row.push(item.description)
        row.push(`${item.temp}°C`)
        row.push(`${item.atemp}°C`)
        row.push(`${item.ahum}%`)
        row.push(`${item.ground_hum}%`)
        row.push(`${item.rain_level}%`)
        row.push(`${item.light_level}%`)
        row.push((item.status === 1 ? 'Alerta' : 'Correcto'))
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    async saveConfig () {
      let seeData = ''
      for (const p in this.fields) {
        if (this.fields[p] === true) seeData += `${p},`
      }
      const params = {
        url: 'modelo/agro/change_view',
        method: 'PUT',
        params: {
          see_data: seeData
        }
      }
      await request(params)
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    resetFilters () {
      this.filters.status = ''
      this.filters.description = ''
    },
    doFilter () {
      if (this.currentx !== 1) { this.currentx = 1 } else { this.getResponse() }
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    }

  },
  sockets: {
    agro (payload) {
      this.response.forEach(toModify => {
        if (toModify.agro_id === payload.uuid) {
          toModify.ahum = payload.ahum
          toModify.atemp = payload.atemp
          toModify.ground_hum = payload.ground_hum
          toModify.rain_level = payload.rain_level
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getResponse()
  },

  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>
